import { NgModule } from '@angular/core';
import { CardModule } from '@com-delta-idp/mnx-skymiles-shared';
import { OffersComponent } from './offers.component';

@NgModule({
  imports: [CardModule],
  declarations: [OffersComponent],
  exports: [OffersComponent]
})
export class OffersModule {}
